import { FormButtonsLayout } from 'framework/ui/layout';
import { useEffect, useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';
import { useFormContext } from 'framework/form';
import { COMPLIANCE_DOCUMENT_STATUS } from 'domain/shared/compliance';

const ComplianceDocumentFormActionButtons = ({
  isEditForm,
  publishView,
  onTogglePublishView,
  onCancel,
  onCancelPreview,
}: {
  isEditForm: boolean;
  publishView: boolean;
  onTogglePublishView?: () => void;
  onCancel: () => void;
  onCancelPreview: () => void;
}) => {
  const { isSubmitEnabled, isLoadingArtifact, submitForm, onChangeCallback } = useFormContext();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (submitting && submitForm) {
      submitForm();
      setSubmitting(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitting]);

  const submitWithStatus = (status: string) => {
    if (onChangeCallback) {
      onChangeCallback({ status });
      setSubmitting(true);
    }
  };

  if (isEditForm) {
    return <FormButtonsLayout submitButtonText="Save" onCancelAction={onCancel} />;
  }

  if (publishView) {
    return (
      <Box display="flex">
        <Button
          color="secondary"
          onClick={() => submitWithStatus(COMPLIANCE_DOCUMENT_STATUS.PUBLISHED)}
          disabled={!isSubmitEnabled || isLoadingArtifact || submitting}
          sx={{ mr: '10px' }}
        >
          Publish
        </Button>

        <Button
          color="primary"
          onClick={() => submitWithStatus(COMPLIANCE_DOCUMENT_STATUS.UNPUBLISHED)}
          disabled={!isSubmitEnabled || isLoadingArtifact || submitting}
          sx={{ mr: '10px' }}
        >
          Upload
        </Button>

        <Button variant="outlined" type="button" onClick={onCancelPreview}>
          Cancel
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Button
        data-testid="submit-button"
        onClick={onTogglePublishView}
        disabled={!isSubmitEnabled || isLoadingArtifact}
        sx={{
          marginRight: '10px',
        }}
      >
        Continue
      </Button>

      <Button data-testid="cancel-btn" variant="outlined" type="button" onClick={onCancel}>
        Cancel
      </Button>
    </Box>
  );
};

export default ComplianceDocumentFormActionButtons;
